import { render, staticRenderFns } from "./DocumentChangeLocationConfirmationDialog.vue?vue&type=template&id=299bd006&scoped=true&lang=pug&"
import script from "./DocumentChangeLocationConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentChangeLocationConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299bd006",
  null
  
)

export default component.exports